jQuery(document).ready(function () {
	"use strict";
	jQuery(".btn-menu").click(function (e) {
		document.body.classList.toggle("menu-open");
	});

	//Remove current menu on anchor links
	var current = jQuery("nav").find(".anchor");
	jQuery(current).removeClass("current-menu-item current_page_item");

	//Scroll when anchor is clicked
	jQuery("nav a[href*=\\#]:not([href=\\#]),a[href*=\\#]:not([href=\\#])").click(function () {
		if (
			location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "") &&
			location.hostname === this.hostname
			(!jQuery(this).closest(".wc-tabs").length)
		) {
			var target = jQuery(this.hash);
			target = target.length ? target : jQuery("[name=" + this.hash.slice(1) + "]");
			if (target.length) {
				if (document.body.classList.contains("menu-open")) {
					document.body.classList.toggle("menu-open");
				}
				var winwidth = window.innerWidth;
				var headerHeight = document.getElementsByTagName("header")[0].offsetHeight;
				headerHeight = headerHeight - 1;
				if (winwidth > 991) {
					jQuery("html,body").animate({ scrollTop: target.offset().top - headerHeight }, 0);
				} else {
					jQuery("html,body").animate({ scrollTop: target.offset().top }, 0);
				}
				return false;
			}
		}
	});
	//Scroll when anchor is loaded
	jQuery(window).on("load", function (e) {
		if (window.location.hash) {
			var target = jQuery(window.location.hash);
			target = target.length ? target : jQuery("[name=" + this.hash.slice(1) + "]");
			var winwidth = window.innerWidth;
			var headerHeight = document.getElementsByTagName("header")[0].offsetHeight;
			headerHeight = headerHeight - 1;
			if (winwidth > 991) {
				jQuery("html,body").animate({ scrollTop: target.offset().top - headerHeight }, 0);
			} else {
				jQuery("html,body").animate({ scrollTop: target.offset().top }, 0);
			}
			return false;
		}
	});
	jQuery("#return-to-top").click(function (e) {
		jQuery("html,body").animate({ scrollTop: 0 }, 0);
	});
	var pullup = document.querySelectorAll(".pull-up,.pull-right,.pull-down,.pull-left");
	jQuery(window).on("load resize scroll", function (e) {
		var scrollTop = window.pageYOffset || document.documentElement.scrollTop,
			bottom = scrollTop + window.innerHeight;
		for (var i = 0; i < pullup.length; i++) {
			var height = pullup[i].offsetHeight,
				bodyRect = document.body.getBoundingClientRect(),
				elemRect = pullup[i].getBoundingClientRect(),
				elementPos = elemRect.top - bodyRect.top - height / 2;
			if (elementPos <= bottom) {
				pullup[i].classList.add("animate");
			}
		}
	});
});
